<app-navbar></app-navbar>
<main>
  <app-sidebar></app-sidebar>
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>